angular.module('app.directives').directive('taskPreview', ($templateCache, $compile) => ({
    restrict: 'EA',

    scope: {
        task: '=',
        iconClass: '@',
    },

    templateUrl: '/directives/preview/task_preview_link.html',

    link(scope, element, attrs) {
        scope.preview = [
            {
                field: 'name',
                value: 'name',
                cssClass: 'uk-width-1-1',
            },
            {
                field: 'date_from',
                value: 'date_from',
            },
            {
                field: 'date_to',
                value: 'date_to',
            },
            {
                field: 'category_id',
                value: 'category.value',
            },
            {
                field: 'status_id',
                value: 'status.value',
            },
            {
                field: 'interest_id',
                value: 'project.name',
            },
            {
                field: 'client_id',
                value: 'client.name',
            },
            {
                field: 'author_id',
                value: 'author.fullname',
            },
            {
                field: 'color',
                value: '',
                cssStyle: `display: block; width: 50px; height: 18px; background-color: #${scope.task.color}`,
            },
            {
                field: 'notes',
                value: 'notes',
                cssClass: 'uk-width-1-1',
            },
        ];

        scope.previewTask = ($event) => {
            const html = $templateCache.get('/directives/preview/task_preview.html');
            angular.element('#preview_task_modal').html($compile(html)(scope));

            return true;
        };

        scope.setupTemplate = () => {
            if (angular.element('#preview_task_wrapper').length) {
                return true;
            }

            angular.element('body').append('<div id="preview_task_wrapper"><div class="uk-modal" id="preview_task_modal" aria-hidden="true"></div></div>');
        };

        scope.setupTemplate();
    },
}));
